import { useTranslation } from 'next-i18next';
import '../events.quiz-image-upload';
import { useTrackEvent } from '@zep/logger/react';
import { FileSearchIcon } from '@/icons/components/FileSearch';
import { ImageInputButton } from '@/shared/components';
import type { ImageUploadModalPlace } from '@/shared/features/image-search/types';
import { useDroppableImageUpload } from '@/shared/hooks';
import { cn } from '@/utils';
export const UploadTabScreen = ({
  onUploadStart,
  place,
  imageUrl,
  multiple = false
}: {
  onUploadStart: (files: File[]) => void;
  place: ImageUploadModalPlace;
  imageUrl?: string;
  multiple?: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const {
    track
  } = useTrackEvent();
  const {
    rootProps,
    inputProps,
    isDragActive,
    inputRef
  } = useDroppableImageUpload({
    onUploadStart,
    imageUrl,
    multiple
  });
  return <div {...rootProps} className={cn('flex size-full min-h-[400px] flex-col items-center justify-center pb-lg', isDragActive && 'bg-gray-50 rounded-sm')} data-sentry-component="UploadTabScreen" data-sentry-source-file="UploadTabScreen.tsx">
      {/* <ImageDropZone */}
      <input {...inputProps} className="hidden" ref={inputRef} />
      <div className="flex flex-col items-center gap-md pb-3xl">
        <FileSearchIcon fill={'#1C1B1F'} className="ml-[4px] h-[116px] w-[130px]" data-sentry-element="FileSearchIcon" data-sentry-source-file="UploadTabScreen.tsx" />
        <div className="flex flex-col items-center gap-lg">
          <ImageInputButton onClick={() => {
          inputRef.current?.click();
          track('image_input_button_click', {
            tab: 'upload',
            place
          });
        }} data-sentry-element="ImageInputButton" data-sentry-source-file="UploadTabScreen.tsx" />
          <span className="hidden text-heading-md-bold text-assistive tablet-sm:block">
            {t('image.uploadTab.description')}
          </span>
        </div>
      </div>
    </div>;
};